import { HttpClient } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { catchError, of, switchMap } from "rxjs";

export interface Contact {
    name: string;
    company: string;
    value: string;
}

export interface ContactQueryResponse {
    items: Contact[];
    totalCount: number;
}

@Injectable({ providedIn: "root" })
export class ContactsService {
    private readonly httpClient = inject(HttpClient);

    public searchContacts(search: Signal<string>): Signal<ContactQueryResponse | undefined> {
        return toSignal(
            toObservable(search).pipe(
                switchMap((value) =>
                    this.httpClient.get<ContactQueryResponse>("/api/contacts", { params: value ? { search: value } : {} }).pipe(catchError(() => of(undefined)))
                )
            )
        );
    }
}
